var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.events
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: { type: "list-item-avatar-three-line" },
          })
        : _vm._e(),
      _vm._v(" "),
      true
        ? _c("v-simple-table", { staticClass: "cursor-pointer" }, [
            _c(
              "tbody",
              _vm._l(_vm.events, function (item, index) {
                return _c(
                  "tr",
                  {
                    key: item.id,
                    on: {
                      click: function ($event) {
                        _vm.clickedLessonDetails = item.lesson_id
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "pl-1 py-4" },
                      [
                        _c("div", {
                          staticClass: "soli-round absolute",
                          class: [_vm.getColor(item)],
                          staticStyle: { width: "3px", height: "72px" },
                        }),
                        _vm._v(" "),
                        _c("AttendanceDate", {
                          staticClass: "pl-6 mx-auto",
                          attrs: {
                            textAlignCenter: "",
                            date: item.lesson.start,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("div", { staticClass: "caption soli-grey" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                item.lesson.instrument_id
                                  ? `${item.lesson.instrument?.name} ${item.lesson.type}`
                                  : item.lesson.group_event.title
                              ) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "soli-grey body-1" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.user.name) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("AttendanceLesson", {
                          attrs: { lesson: item.lesson },
                        }),
                        _vm._v(" "),
                        _vm.showChips(item)
                          ? _c(
                              "div",
                              { staticClass: "flex py-1" },
                              [
                                !item.purchase_option.paid
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2 white--text",
                                        attrs: {
                                          "x-small": "",
                                          color: "soli-status-red",
                                        },
                                      },
                                      [_vm._v("Unpaid")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.status
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2 white--text",
                                        attrs: {
                                          "x-small": "",
                                          color:
                                            item.status == "Attended"
                                              ? "soli-attendance-green"
                                              : "dark",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(item.status)
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.converted
                                  ? _c(
                                      "v-chip",
                                      {
                                        staticClass: "mr-2 white--text",
                                        attrs: {
                                          "x-small": "",
                                          color: "accent",
                                        },
                                      },
                                      [_vm._v("Enrolled")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.$vuetify.breakpoint.smAndUp
                      ? _c(
                          "td",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "align-self-center",
                                attrs: { icon: "", color: "secondary" },
                              },
                              [
                                _c("v-icon", [
                                  _vm._v("arrow_drop_down_circle"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "v-list",
            { staticClass: "pa-0" },
            _vm._l(_vm.events, function (item, index) {
              return _c(
                "v-list-item",
                {
                  key: item.id,
                  staticClass: "soli-round",
                  class: { "mb-3": _vm.idx < _vm.events.length - 1 },
                  staticStyle: { "overflow-x": "auto" },
                  on: {
                    click: function ($event) {
                      _vm.clickedLessonDetails = item.lesson_id
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "w-16 mr-8" },
                    [
                      _c("AttendanceDate", {
                        attrs: { date: item.lesson.start, textAlignCenter: "" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    { staticClass: "text-align-start" },
                    [
                      _c("div", { staticClass: "caption soli-grey" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              item.lesson.instrument_id
                                ? `${item.lesson.instrument?.name} ${item.lesson.type}`
                                : item.lesson.group_event.title
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: _vm.$vuetify.breakpoint.xsOnly
                            ? "body-2"
                            : "body-1",
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.user.name) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("AttendanceLesson", {
                        attrs: { lesson: item.lesson },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          !item.purchase_option.paid
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2 white--text",
                                  attrs: {
                                    "x-small": "",
                                    color: "soli-status-red",
                                  },
                                },
                                [_vm._v("Unpaid")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.status
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2 white--text",
                                  attrs: {
                                    "x-small": "",
                                    color:
                                      item.status == "Attended"
                                        ? "soli-attendance-green"
                                        : "dark",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.status)
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.converted
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2 white--text",
                                  attrs: { "x-small": "", color: "accent" },
                                },
                                [_vm._v("Enrolled")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$vuetify.breakpoint.smAndUp
                    ? _c(
                        "v-list-item-action",
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "align-self-center",
                              attrs: { icon: "", color: "secondary" },
                            },
                            [_c("v-icon", [_vm._v("arrow_drop_down_circle")])],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.clickedLessonDetails
        ? _c("LessonDetail", {
            ref: "details",
            attrs: {
              errors: _vm.$page.props.errors,
              auth: _vm.$page.props.auth,
              lessonId: _vm.clickedLessonDetails,
            },
            on: {
              reset: function ($event) {
                _vm.clickedLessonDetails = null
              },
              success: _vm.handleSuccess,
              rescheduleLesson: function ($event) {
                ;[
                  (_vm.clickData = $event),
                  (_vm.bookingForm = true),
                  (_vm.clickedLessonDetails = null),
                ]
              },
              showMessage: function ($event) {
                return _vm.$emit("success")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.bookingForm
        ? _c("CreateLesson", {
            attrs: {
              errors: _vm.errors,
              event: _vm.clickData,
              bookingSource: {
                isNew: false,
                isCalendar: false,
                isMySchedule: false,
                isReschedule: true,
              },
            },
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.bookingForm = false))
              },
              success: _vm.handleSuccess,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }